// extracted by mini-css-extract-plugin
export default {"base":"logo-local__base___uEurQ5p6","dark":"logo-local__dark___rhOE92iH","light":"logo-local__light___nJymAEVG","currentColor":"logo-local__currentColor___hEMRkba3"};